/*
const loginButton = document.querySelector("#classic-button-login");
const login = () => {
  loginButton.setAttribute("inprogress", "true");
  setTimeout(() => {
    loginButton.removeAttribute("inprogress");
    console.log("login response");
  }, 2000);
};

const registerButton = document.querySelector("#classic-button-register");
const register = () => {
  registerButton.setAttribute("inprogress", "true");
  setTimeout(() => {
    registerButton.removeAttribute("inprogress");
    console.log("register response");
  }, 2000);
};
*/

if (!customElements.get("app-ration-calculator")) {
  customElements.define(
    "app-ration-calculator",
    class AppRationCalculator extends HTMLElement {
      constructor() {
        super();

        this.resultsMode = this.dataset.resultsMode || "email";
        this.currentUrl = null;

        this.labels = this.querySelectorAll("label span.replace");

        this.cat = {};

        this.cat["catName"] = "";
        this.cat["catSexe"] = "";
        this.cat["catAge"] = "";
        this.cat["catSterilised"] = "";
        this.cat["catOutdoor"] = "";
        this.cat["catWeight"] = "";
        this.cat["catWeightType"] = "";
        this.cat["catOptimalWeight"] = "";
        this.cat["catBreed"] = "";
        this.cat["catVet"] = "";
        this.cat["catAlim"] = "0.5";

        this.cat["deliveryQuantity"] = 28;

        this.querySelector('app-input[name="catVet"]').classList.add("hidden");
        this.querySelector('app-input[name="catOutdoor"]').classList.add(
          "hidden",
        );
        //}
        if (this.cat.catWeightType === "")
          this.querySelector(
            'app-input[name="catOptimalWeight"]',
          ).classList.add("hidden");
      }

      connectedCallback() {
        const button = this.querySelector("#rationButton");
        if (button) {
          button.addEventListener("click", () => {
            this.showFinalResults();
            const wrapper = this.querySelector("#rationButtonWrapper");
            if (wrapper) {
              wrapper.classList.add("hidden");
            }
          });
        }

        this.querySelectorAll("[data-question]").forEach((el) => {
          if (!el.dataset.template) {
            el.dataset.template = el.textContent;
          }
        });

        this.addEventListener("app-input", (event) => {
          if (event.detail.name === "catName") {
            this.setAttribute("cat", event.detail.value);
          }

          if (event.detail.name === "catSexe") {
            this.setAttribute("sexe", event.detail.value);
          }

          // Empty catOptimalWeight field on catWeightType change
          if (event.detail.name === "catWeightType") {
            this.querySelector(
              `app-input[name='catOptimalWeight'] .icon--survey-tick`,
            ).classList.add("empty");
            this.querySelector(
              `app-input[name='catOptimalWeight'] input`,
            ).value = "";
            this.cat.catOptimalWeight = "";
          }

          // Empty catVet field on catAge change && set catOutdoor
          if (event.detail.name === "catAge") {
            this.querySelector(`app-input[name='catVet'] select`).value = "";
            this.querySelector(
              `app-input[name='catVet'] .icon--survey-tick`,
            ).classList.add("empty");
            if (this.cat.catAge >= 12) {
              this.querySelector('app-input[name="catVet"]').classList.remove(
                "hidden",
              );
              this.querySelector(`app-input[name='catOutdoor'] input`).value =
                "";
            } else {
              this.querySelector('app-input[name="catVet"]').classList.add(
                "hidden",
              );
              // this.querySelector(`app-input[name='catOutdoor'] input`).value = "false";
            }
          }

          this.cat[`${event.detail.name}`] = event.detail.value;

          // Conditionnal display
          if (!this.cat.catAge || this.cat.catAge < 12) {
            this.cat.catOutdoor = "false";
            this.querySelector('app-input[name="catOutdoor"]').classList.add(
              "hidden",
            );
          }
          if (this.cat.catAge && this.cat.catAge >= 12)
            this.querySelector('app-input[name="catOutdoor"]').classList.remove(
              "hidden",
            );

          if (!this.cat.catAge || this.cat.catAge < 12) {
            this.cat.catVet = "";
            this.querySelector('app-input[name="catVet"]').classList.add(
              "hidden",
            );
          }
          if (!this.cat.catWeightType || this.cat.catWeightType === "optimal") {
            this.cat.catOptimalWeight = "";
            this.querySelector(
              'app-input[name="catOptimalWeight"]',
            ).classList.add("hidden");
          }

          if (this.cat.catAge && this.cat.catAge >= 12)
            this.querySelector('app-input[name="catVet"]').classList.remove(
              "hidden",
            );
          if (this.cat.catWeightType && this.cat.catWeightType !== "optimal") {
            this.querySelector(
              'app-input[name="catOptimalWeight"]',
            ).classList.remove("hidden");
          }

          // Validate answer with tick
          if (
            this.querySelector(
              `app-input[name='${event.detail.name}'] .icon--survey-tick`,
            )
          )
            this.cat[`${event.detail.name}`] !== ""
              ? this.querySelector(
                  `app-input[name='${event.detail.name}'] .icon--survey-tick`,
                ).classList.remove("empty")
              : this.querySelector(
                  `app-input[name='${event.detail.name}'] .icon--survey-tick`,
                ).classList.add("empty");

          let catDataType = this.catDataType(this.cat);

          if (!catDataType) {
            const i18n = this.getI18n();
            this.querySelector(
              'app-input[name="catAlim"] .helper-text',
            ).innerText = i18n?.form_error || "";
            if (
              this.querySelector("#rationImage").classList.contains("hidden")
            ) {
              this.querySelectorAll(".js-results").forEach((result) =>
                result.classList.toggle("hidden"),
              );
            }
            return;
          }
          this.querySelector(
            'app-input[name="catAlim"] .helper-text',
          ).innerText = "";
          if (this.querySelector("#rationDatas")) {
            try {
              // Get results from _rations-data.json.liquid
              const result = this.querySelector("#rationDatas").innerHTML;
              const data = JSON.parse(result);

              let BE = data[`${catDataType}`].BE;
              let wetCal = data[`${catDataType}`].wetCal;
              let dryCal = data[`${catDataType}`].dryCal;

              let catWeight = this.cat.catWeight;
              if (
                this.catWeightType !== "" &&
                this.catWeightType !== "optimal" &&
                this.cat.catOptimalWeight !== ""
              )
                catWeight = this.cat.catOptimalWeight;

              // Products to render
              let collection = data[`${catDataType}`].collection;

              this.renderCollection(collection);

              this.cat.catOutdoor === "true" ? (BE = BE + 5) : (BE = BE);

              // Display results
              if (
                this.querySelector("#rationResults").classList.contains(
                  "hidden",
                )
              ) {
                this.querySelectorAll(".js-results").forEach((result) =>
                  result.classList.toggle("hidden"),
                );
              }

              this.querySelectorAll(".js-vet-recos").forEach((reco) => {
                reco.classList.add("hidden");
                if (reco.dataset.vet === this.cat.catVet)
                  reco.classList.remove("hidden");
              });

              let totalBE = BE * catWeight;
              this.querySelector("#BE").textContent = totalBE;

              let wetRatio = Number(this.cat.catAlim);

              const i18n = this.getI18n();
              const deliveryQty = Number(this.cat.deliveryQuantity);

              if (!i18n) return;

              if (wetRatio === 0) {
                const dailyDry = Math.ceil(totalBE / dryCal);
                //const orderDry = Math.ceil((dailyDry * deliveryQty) / 1000);
                //const orderDry = (dailyDry * deliveryQty) / 1000;
                const orderDry = Number(
                  (Math.ceil((dailyDry * deliveryQty) / 100) / 10).toFixed(1),
                );

                this.cat.ziggyPrecos = this.formatTemplate(i18n.dry_daily, {
                  qty: dailyDry,
                });

                this.ziggyOrder = this.formatTemplate(i18n.dry_order, {
                  qty: orderDry,
                });

                this.cat.ziggyMail = this.ziggyOrder;
              } else if (wetRatio === 1) {
                const dailyWet = Math.ceil(totalBE / wetCal);
                const totalWetUnits = Math.ceil((dailyWet * deliveryQty) / 100);
                const wetLots = Math.ceil(totalWetUnits / 16);

                this.cat.ziggyPrecos = this.formatTemplate(i18n.wet_daily, {
                  qty: dailyWet,
                });

                this.ziggyOrder = this.formatTemplate(i18n.wet_order, {
                  qty: totalWetUnits,
                  lots: wetLots,
                });

                this.cat.ziggyMail = this.ziggyOrder;
              } else {
                const dailyDry = Math.ceil((totalBE * (1 - wetRatio)) / dryCal);
                const dailyWet = Math.ceil((totalBE * wetRatio) / wetCal);

                //const orderDryKg = Math.ceil((dailyDry * deliveryQty) / 1000);
                const orderDryKg = Number(
                  (Math.ceil((dailyDry * deliveryQty) / 100) / 10).toFixed(1),
                );
                const totalWetUnits = Math.ceil((dailyWet * deliveryQty) / 100);
                const wetLots = Math.ceil(totalWetUnits / 16);

                this.cat.ziggyPrecos = this.formatTemplate(i18n.mix_daily, {
                  dry: dailyDry,
                  wet: dailyWet,
                });

                this.ziggyOrder = this.formatTemplate(i18n.mix_order, {
                  dry: orderDryKg,
                  wet: totalWetUnits,
                  lots: wetLots,
                });

                this.cat.ziggyMail = this.ziggyOrder;
              }

              this.querySelector("#ziggyPrecos").innerHTML =
                this.cat.ziggyPrecos;
              this.querySelector("#ziggyOrder").innerHTML = this.ziggyOrder;

              console.log("CAT FINAL", this.cat);

              /*
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push([
            "identify",
            {
              cat_ration_name: this.cat.catName || "Votre Chat",
              cat_ration_BE: totalBE,
              cat_ration_breed: this.cat.catBreed,
              cat_ration_BE: totalBE,
              cat_ration_age: this.cat.catAge / 12,
              cat_ration_sterilized: this.cat.catSterilised,
              cat_ration_weight: catWeight,
              cat_ration_weightType: this.cat.catWeightType,
              cat_ration_foodType: wetRatio,
              cat_ration_results: this.cat.ziggyPrecos,
              cat_ration_frequency: "",
              cat_ration_order: this.cat.ziggyMail,
            },
          ]);
          */
            } catch (error) {
              console.log("ERROR", error);
            }
          }
        });
        this.renderDynamicQuestions();
      }

      formatTemplate(template, vars) {
        return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
          return vars[key] ?? "";
        });
      }

      getI18n() {
        // cherche d'abord dans le composant
        let el = this.querySelector("#rationI18nData");
        // fallback si section injectée ailleurs
        if (!el) {
          el = document.querySelector("#rationI18nData");
        }
        if (!el) return null;

        const decodeHtmlEntities = (value) => {
          if (typeof value === "string") {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = value;
            return textarea.value;
          }

          if (Array.isArray(value)) {
            return value.map(decodeHtmlEntities);
          }

          if (value && typeof value === "object") {
            return Object.fromEntries(
              Object.entries(value).map(([key, val]) => [
                key,
                decodeHtmlEntities(val),
              ]),
            );
          }
          return value;
        };

        try {
          return decodeHtmlEntities(JSON.parse(el.textContent));
        } catch (e) {
          console.warn("Invalid rationI18n JSON");
          return null;
        }

        /*try {
          return JSON.parse(el.textContent);
        } catch (e) {
          console.warn("Invalid rationI18n JSON");
          return null;
        }*/
      }

      renderDynamicQuestions() {
        const i18n = this.getI18n();
        if (!i18n) return;

        const rawName = this.getAttribute("cat");
        const selectedSexe = this.getAttribute("sexe");

        const name =
          rawName && rawName.trim() !== "" ? rawName : i18n.defaultName || "";

        const sexeForIs = selectedSexe || "male";
        const dict = i18n[sexeForIs] || {};

        if (!dict) return;

        this.querySelectorAll("[data-question]").forEach((el) => {
          let template = el.dataset.template;
          if (!template) return;

          template = template.replaceAll("{NAME}", name);
          template = template.replaceAll("{IS}", dict.IS || "");
          template = template.replaceAll("{HAS}", dict.HAS || "");

          if (selectedSexe) {
            template = template.replaceAll(
              "{STERILIZED}",
              dict.STERILIZED || "",
            );
          } else {
            template = template.replaceAll("{STERILIZED}", dict.STERILIZED);
          }
          template = template.replace(/\s{2,}/g, " ").trim();

          el.textContent = template;
        });
      }

      catDataType(cat) {
        // console.log("CAT", cat);
        // Debug - Hide in production
        // this.querySelector('#testCat').innerHTML = JSON.stringify(cat).replaceAll(",", '<br>');
        // console.log('CAT', Object.keys(this.cat).length);

        // Test if weight is completed
        // console.log("WEIGHT CONDITION_0");
        const i18n = this.getI18n();
        if (this.cat.catName === "") {
          this.querySelector(`app-input[name='catName']`).setAttribute(
            "help",
            i18n?.name_required || "",
          );
          this.querySelector(
            `app-input[name='catName'] .icon--survey-tick`,
          )?.classList.add("empty");
        } else {
          this.querySelector(`app-input[name='catName']`).removeAttribute(
            "help",
          );
        }
        if (
          this.cat.catWeight === "" &&
          (this.cat.catWeightType !== "" || this.cat.catOptimalWeight !== "")
        ) {
          this.querySelector(`app-input[name='catWeight']`).setAttribute(
            "help",
            i18n?.help_weight_current || "",
          );
          this.querySelector(
            `app-input[name='catWeight'] .icon--survey-tick`,
          ).classList.add("empty");
        } else {
          this.querySelector(`app-input[name='catWeight']`).removeAttribute(
            "help",
          );
          if (this.cat.catWeight !== "")
            this.querySelector(
              `app-input[name='catWeight'] .icon--survey-tick`,
            ).classList.remove("empty");
        }

        if (this.cat.catWeightType !== "optimal") {
          // console.log("WEIGHT CONDITION");
          let weightCondition =
            this.cat.catWeight !== "" && this.cat.catOptimalWeight !== "";
          if (
            this.cat.catWeightType === "under" &&
            this.cat.catOptimalWeight !== "" &&
            Number(this.cat.catOptimalWeight) <= Number(this.cat.catWeight)
          ) {
            this.querySelector(
              `app-input[name='catOptimalWeight']`,
            ).setAttribute("help", i18n?.help_weight_optimal || "");
            weightCondition = false;
          } else if (
            this.cat.catWeightType === "over" &&
            this.cat.catOptimalWeight !== "" &&
            Number(this.cat.catOptimalWeight) >= Number(this.cat.catWeight)
          ) {
            this.querySelector(
              `app-input[name='catOptimalWeight']`,
            ).setAttribute("help", i18n?.help_weight_lower || "");
            weightCondition = false;
          } else {
            this.querySelector(
              `app-input[name='catOptimalWeight']`,
            ).removeAttribute("help");
            weightCondition = true;
          }
          console.log("WEIGHT CONDITION", weightCondition);
          if (!weightCondition) return false;
        }

        // Test if form is completed
        let minCondition =
          this.cat.catName !== "" &&
          this.cat.catAge !== "" &&
          this.cat.catSterilised !== "" &&
          this.cat.catSexe !== "" &&
          this.cat.catOutdoor !== "" &&
          this.cat.catWeight !== "" &&
          this.cat.catWeightType !== "" &&
          this.cat.catBreed !== "";
        console.log("MIN COMPLETED", minCondition);
        if (!minCondition) return false;

        // Test if vet is completed if adult
        if (this.cat.catAge >= 12) {
          let vetCondition = minCondition && this.cat.catVet !== "";
          //console.log('ADULT COMPLETED', vetCondition)
          if (!vetCondition) return false;
        }

        const age = this.cat.catAge;
        switch (true) {
          case age < 5:
            let ration_chaton_0 =
              this.cat.catSterilised === "true"
                ? "ration_chaton_0_sterilise"
                : "ration_chaton_0";
            return ration_chaton_0;
            break;
          case age < 7:
            let ration_chaton_1 =
              this.cat.catSterilised === "true"
                ? "ration_chaton_1_sterilise"
                : "ration_chaton_1";
            return ration_chaton_1;
            break;
          case age < 12:
            let ration_chaton_2 =
              this.cat.catSterilised === "true"
                ? "ration_chaton_2_sterilise"
                : "ration_chaton_2";
            return ration_chaton_2;
            break;
          case age <= 108:
            let ration =
              this.cat.catSterilised === "true"
                ? "ration_sterilise"
                : "ration_entier";
            if (
              this.cat.catVet === "irc" ||
              this.cat.catVet == "diabete" ||
              this.cat.catVet == "uro"
            ) {
              ration = `ration_${this.cat.catVet}`;
            }
            if (this.cat.catBreed !== "" && this.cat.catBreed == "maine-coon") {
              ration = "ration_maine-coon";
            }
            return ration;
            break;
          case age <= 216:
            return "ration_senior";
            break;
          default:
            return false;
        }
      }

      renderCollection(handle) {
        if (!handle) return;

        const root = window.Shopify?.routes?.root || "/";
        const basePath = `${root}collections/${handle}`;

        const url = new URL(basePath, window.location.origin);

        switch (this.cat.catAlim) {
          case "0":
            url.searchParams.append(
              "filter.p.m.ziggy.ration_filters",
              "croquettes",
            );
            break;

          case "1":
            url.searchParams.append(
              "filter.p.m.ziggy.ration_filters",
              "patees",
            );
            break;
        }

        const finalUrl = url.toString();

        // 🔎 Guard basé sur l’URL finale
        if (this.currentUrl === finalUrl) return;

        this.currentUrl = finalUrl;

        console.log("Collection URL", finalUrl);

        fetch(finalUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const doc = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const container = doc.getElementById("ProductGridContainer");
            if (!container) {
              console.warn("ProductGridContainer not found");
              this.currentUrl = null; // permet de retenter plus tard
              return;
            }
            this.querySelector("#surveyProducts").innerHTML =
              container.innerHTML;
          })
          .catch((error) => {
            console.error("Collection fetch error:", error);
            this.currentUrl = null; // permet retry
          });
      }

      static get observedAttributes() {
        return ["cat", "sexe"];
      }

      attributeChangedCallback(attribute, oldValue, newValue) {
        console.log(attribute, oldValue, newValue);
        console.log('getAttribute("cat")', this.getAttribute("cat"));

        if (oldValue === newValue) return;

        if (attribute === "cat" || attribute === "sexe") {
          this.renderDynamicQuestions();
        }
      }

      showFinalResults() {
        const recos = this.querySelector("#rationRecos");
        const products = this.querySelector("#rationProducts");
        const emailField = this.querySelector("#rationGetEmail");

        if (emailField) emailField.classList.add("hidden");
        if (recos) recos.classList.remove("hidden");
        if (products) products.classList.remove("hidden");
      }
    },
  );
}

if (!customElements.get("app-input")) {
  customElements.define(
    "app-input",
    class AppInput extends HTMLElement {
      constructor() {
        super();

        this.name = "";
        this.type = "";

        this.span = this.querySelector(".helper-text");

        const app = this.closest("app-ration-calculator");
        this.cat = app.getAttribute("cat");
      }

      get help() {
        return this.getAttribute("help");
      }

      set help(help) {
        this.setAttribute("help", help);
      }

      get validation() {
        return this.getAttribute("validation");
      }

      set validation(validation) {
        this.setAttribute("validation", validation);
      }

      connectedCallback() {
        this.span.textContent = this.getAttribute("help");
        this.type = this.getAttribute("type");
        this.name = this.getAttribute("name");

        const input = this.querySelector(`${this.type}`);
        //input.type = this.getAttribute("type");

        input.addEventListener("change", (event) => {
          // console.log("EVENT", event.target);
          let value = event.target.value;
          if (value.includes(",")) {
            value = event.target.value.replace(",", ".");
          }
          event.stopPropagation();
          input.dispatchEvent(
            new CustomEvent("app-input", {
              bubbles: true,
              composed: true,
              detail: { type: this.type, name: this.name, value: value.trim() },
            }),
          );
        });
      }

      static get observedAttributes() {
        return ["help"];
      }

      attributeChangedCallback(attribute, oldValue, newValue) {
        this.span.textContent = newValue;
      }
    },
  );
}

if (!customElements.get("app-button")) {
  customElements.define(
    "app-button",
    class AppButton extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const text = this.getAttribute("text");
        this.innerHTML = `<button class='btn btn--primary'>${text}</button>`;
      }

      set inprogress(progress) {
        if (progress) {
          this.setAttribute("inprogress", "true");
        } else {
          this.removeAttribute("inprogress");
        }
      }

      get inprogress() {
        return this.getAttribute("inprogress");
      }

      static get observedAttributes() {
        return ["inprogress"];
      }

      attributeChangedCallback(attribute, oldValue, newValue) {
        console.log(attribute, oldValue, newValue);
        const button = this.querySelector("button");

        if (newValue) {
          button.textContent = "Loading...";
          button.setAttribute("disabled", "true");
        }
      }
    },
  );
}

//1 mois, 2 mois, 3 mois, 4 mois, 5 mois, 6 mois, 7 mois, 8 mois, 9 mois, 10 mois, 11 mois, 1 an, 2 ans, 3 ans, 4 ans, 5 ans, 6 ans, 7 ans, 8 ans, 9 ans, 10 ans, 11 ans, 12 ans, 13 ans, 15 ans, 16 ans, 17 ans, 18 ans

function capitalizeFirstLetter(string) {
  return string.replace(/^./, string[0].toUpperCase());
}

function showCalculatorInModal() {
  const root = window.Shopify?.routes?.root || "/";
  let url = `${root}pages/calculateur-de-ration`;

  console.log("URL", url);

  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const new_html = new DOMParser()
        .parseFromString(responseText, "text/html")
        .getElementById("rationCalculator2024").innerHTML;
      document.querySelector("#calculator2024").innerHTML = new_html;
    });
}

window.addEventListener("klaviyoForms", (evt) => {
  if (evt.detail.formId == "UBqcRb" && evt.detail.type == "stepSubmit") {
    console.log("EVENT", evt);
    /*document.querySelector("#rationGetEmail").classList.add("hidden");
    document.querySelector("#rationRecos").classList.remove("hidden");
    document.querySelector("#rationProducts").classList.remove("hidden");*/
    const calculator = document.querySelector("app-ration-calculator");
    if (calculator && typeof calculator.showFinalResults === "function") {
      calculator.showFinalResults();
    }
    calculator.showFinalResults();
  }
});
